import React from 'react';
import { Fragment } from 'react';
import { Link } from 'gatsby';
import { LocalizedLink } from 'gatsby-plugin-i18n-l10n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

export const Services = () => (
  <Fragment>
    <li>
      <LocalizedLink to="/services/#desktop">Aplikacje webowe</LocalizedLink>
    </li>
    <li>
      <LocalizedLink to="/services/#mobile">Aplikacje mobilne</LocalizedLink>
    </li>
    <li>
      <LocalizedLink to="/services/#product">Projektowanie produktu</LocalizedLink>
    </li>
    <li>
      <LocalizedLink to="/services/#rnd">Projekty B+R</LocalizedLink>
    </li>
    <li>
      <LocalizedLink to="/services/#uxui">UX/UI Design</LocalizedLink>
    </li>
    <li>
      <LocalizedLink to="/services/#outsourcing">Outsourcing pracowników</LocalizedLink>
    </li>
    <li>
      <LocalizedLink to="/services/#cryptography">Kryptografia</LocalizedLink>
    </li>
    <li>
      <LocalizedLink to="/services/#2fa">Uwierzytelnianie dwuskładnikowe</LocalizedLink>
    </li>
  </Fragment>
);

export const Projects = () => (
  <Fragment>
    <li>
      <a href="https://generacja-l.pl/" target="_blank">
        Lubuski portal Generacj-L<sup><FontAwesomeIcon icon={faUpRightFromSquare} size="2xs" /></sup>
      </a>
    </li>
    <li>
      <a href="https://wmz.generacja-l.pl/" target="_blank">
        Wirtualne Miasteczko Zawodów<sup><FontAwesomeIcon icon={faUpRightFromSquare} size="2xs" /></sup>
      </a>
    </li>
    <li>
      <Link to="/wypelnij-wniosek">Wypelnij-Wniosek.pl</Link>
    </li>
    <li>
      <Link to="/swiete-kroki">Aplikacja turystyczno-informacyjna Święte Kroki</Link>
    </li>
    <li>
      <Link to="/sklep-eset">Platforma zakupowa licencji ESET</Link>
    </li>
    <li>
      <Link to="/porownywarka">Porównywarka urządzeń z generatorem ofert</Link>
    </li>
    <li>
      <Link to="/safe-quiz">System przetwarzania ankiet</Link>
    </li>
  </Fragment>
);

export const Blog = () => (
  <Fragment>
    <li>
      <Link to="/blog">Blog Page</Link>
    </li>
    <li>
      <Link to="/blog-details">Blog Details</Link>
    </li>
  </Fragment>
);
